

import { mainSlider } from "./components/swiper";
import { lightbox } from "./components/lightbox";

import Accordion from "./components/accordion";



$(() => {



    mainSlider();
    lightbox();
    new Accordion();


});








// WEBPACK FOOTER //
// ./src/js/app.js